import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import modules_09e1f5ae from '../styles/Row.module.less.js';

/**
 * @description Container element for Grid system.
 *
 * @component
 * @example
 * ```jsx
 * <Row gutter={[20, 20]} wrap>
 *   ...columns
 * </Button>
 * ```
 */
const Row = React.forwardRef((props, ref) => {
    const { className, gutter, align = 'top', justify, wrap, style, children, ...restProps } = props;
    const cx = useStyles(modules_09e1f5ae);
    const classNames = cx(className, 'container', {
        wrap,
        [`align-${align}`]: align,
        [`justify-${justify}`]: justify,
    });
    const gutters = React.useMemo(() => {
        const results = [0, 0];
        const normalizedGutter = Array.isArray(gutter) ? gutter : [gutter, 0];
        normalizedGutter.forEach((g, index) => {
            results[index] = g || 0;
        });
        return results;
    }, [gutter]);
    const rowStyle = { ...style };
    const horizontalGutter = gutters[0] > 0 ? gutters[0] / -2 : undefined;
    if (horizontalGutter) {
        rowStyle.marginLeft = horizontalGutter;
        rowStyle.marginRight = horizontalGutter;
    }
    const additionalProps = React.useMemo(() => ({ gutters }), [gutters]);
    return (React.createElement("div", { "data-qa": "Row", ref: ref, className: classNames, style: { ...rowStyle }, ...restProps }, React.Children.map(children, (child) => React.isValidElement(child) ? React.cloneElement(child, additionalProps) : child)));
});
Row.defaultProps = {
    gutter: 0,
    align: 'top',
    justify: 'start',
    wrap: true,
};
Row.displayName = 'Row';

export { Row };
//# sourceMappingURL=Row.js.map
